import type React from 'react';

import { FaviconContainer } from './Favicon';
import { MetaContainer } from './Meta';

export const HeadContainer: React.FC = () => {
	return (
		<>
			<MetaContainer />
			<FaviconContainer />
		</>
	);
};
